export const SERVER_HOST = 'https://demo.lfs.rest/api'
